import React from "react";
import closeIcon from "../../../../../assets/icons/closeIcon.svg";
import InitiMSG from "../../../../../assets/icons/InitiMSG.svg";
import SuccessMSG from "../../../../../assets/icons/Success.svg";
import "./company-dashboard-initiative-drawer-header.scss";

const CompanyDashboardInitiativeDrawerHeader: any = (props: any) => {
  const {
    setIsShowInitiativeDrawer,
    isShowMsg,
    isShowSuccessMsg,
    fetchInitiatives,
    fetchUpcomingMilestones,
    fetchAllYearsForInitiatives,
    fetchAllYearsForObjectives,
  } = props;

  return (
    <div className="company-dashboard-initiative-drawer-header">
      <div className="company-dashboard-initiative-drawer-header-content">
        <div className="company-dashboard-initiative-drawer-header-content-label">
          <div>Initiative Detail</div>
          {isShowMsg ? (
            <div className="beta-label">
              <img src={InitiMSG} alt="Initi MSG" />
              <span>
                This initiative is significantly behind schedule. Please review
                progress.
              </span>
            </div>
          ) : null}
          {isShowSuccessMsg ? (
            <div className="beta-label">
              <img src={SuccessMSG} alt="Success icon" />
              <span>Looks like everything is on track here</span>
            </div>
          ) : null}
        </div>
        <div className="company-dashboard-initiative-drawer-header-content-action">
          <button
            style={{
              background: "none",
              border: "none",
              padding: 0,
              cursor: "pointer",
            }}
            onClick={() => {
              setIsShowInitiativeDrawer(false);
              if (fetchInitiatives) fetchInitiatives();
              if (fetchUpcomingMilestones) fetchUpcomingMilestones({});
              if (fetchAllYearsForInitiatives) fetchAllYearsForInitiatives();
              if (fetchAllYearsForObjectives) fetchAllYearsForObjectives();
            }}
          >
            <img
              src={closeIcon}
              alt="close"
              className="company-dashboard-initiative-drawer-header-content-action-close"
            />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CompanyDashboardInitiativeDrawerHeader;
